﻿/**
 * portal-link-role.repository
 * @namespace portal
 */

(function () {
	'use strict';

	/** add the repo */
	angular.module('nha.portal').service('portal-link-role.repository', portalLinkRoleRepo);

	/** injection */
	portalLinkRoleRepo.$inject = ['repositoryFactory', 'PortalRestangular'];

	/** implementation */
	function portalLinkRoleRepo(repositoryFactory, portalRestangular) {
		/** create the repo */
		var repo = new repositoryFactory('PortalLinkRole', portalRestangular);

		/** return the repo */
		return repo;
	}
})();